var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b;
import apolloClient from '@/graphql/apollo-client';
import { GetSession } from '@/graphql/queries/users';
import { getInitials } from '@/utils/user';
export var MUTATIONS = {
    SET_USER: 'mutations/session/setUser',
    SET_USER_STATUS: 'mutations/session/setUserStatus',
    SET_NOTIFICATIONS: 'mutations/session/setNotifications',
    SET_NOTIFICATIONS_STATUS: 'mutations/session/setNotificationsStatus',
};
export var ACTIONS = {
    LOAD_SESSION: 'actions/session/loadSession',
    CLEAR_NOTIFICATIONS: 'actions/session/clearNotifications',
};
export var sessionModule = {
    state: {
        user: {
            data: {},
            status: 'init',
        },
        notifications: {
            data: [],
            paginatorInfo: {},
            status: 'init',
        },
    },
    getters: {
        initials: function (state) {
            return getInitials(state.user.data);
        },
        hasSession: function (state) {
            return !!(state.user.data.first_name && state.user.data.last_name);
        },
    },
    mutations: (_a = {},
        _a[MUTATIONS.SET_USER] = function (state, user) {
            state.user = { data: user, status: state.user.status };
        },
        _a[MUTATIONS.SET_USER_STATUS] = function (state, status) {
            state.user.status = status;
        },
        _a[MUTATIONS.SET_NOTIFICATIONS] = function (state, notifications) {
            state.notifications = __assign(__assign({}, notifications), { status: state.user.status });
        },
        _a[MUTATIONS.SET_NOTIFICATIONS_STATUS] = function (state, status) {
            state.notifications.status = status;
        },
        _a),
    actions: (_b = {},
        _b[ACTIONS.LOAD_SESSION] = function (_a) {
            var commit = _a.commit;
            return __awaiter(this, void 0, void 0, function () {
                var response, err_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            commit(MUTATIONS.SET_USER_STATUS, 'loading');
                            commit(MUTATIONS.SET_NOTIFICATIONS_STATUS, 'loading');
                            return [4 /*yield*/, apolloClient.query({
                                    query: GetSession,
                                })];
                        case 1:
                            response = _b.sent();
                            if (response.data.me) {
                                commit(MUTATIONS.SET_USER, response.data.me);
                            }
                            if (response.data.notifications) {
                                commit(MUTATIONS.SET_NOTIFICATIONS, response.data.notifications);
                            }
                            commit(MUTATIONS.SET_USER_STATUS, 'success');
                            commit(MUTATIONS.SET_NOTIFICATIONS_STATUS, 'success');
                            return [2 /*return*/, true];
                        case 2:
                            err_1 = _b.sent();
                            commit(MUTATIONS.SET_USER_STATUS, 'error');
                            commit(MUTATIONS.SET_NOTIFICATIONS_STATUS, 'error');
                            return [2 /*return*/, false];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        _b[ACTIONS.CLEAR_NOTIFICATIONS] = function (_a) {
            var commit = _a.commit, state = _a.state;
            commit(MUTATIONS.SET_NOTIFICATIONS, {
                data: [],
                paginatorInfo: __assign(__assign({}, state.notifications.paginatorInfo), { total: 0, currentPage: 0, hasMorePages: false }),
            });
        },
        _b),
};
